import { SubscriptionApi } from "../Repository/eventbookyapi";
import { createSubscriptionRequest } from "../Types/RequestResponse/createSubscriptionRequest";
import { GetApiConfiguration } from "./ServiceConfiguration";
import { downloadBlobFile, getFileNameFromContentDisposition } from "../Helpers/FileDownloadHelper";

export abstract class SubscriptionService {
    public static CreateSubscription = async (request: createSubscriptionRequest) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include' as RequestCredentials,
            body: JSON.stringify(request)
        };
        const response = await fetch(process.env.REACT_APP_API_URL + '/Subscription/create', requestOptions);
        const data = await response.json();

        return data;
    };

    public static GetAccount = async () => {
        return new SubscriptionApi(GetApiConfiguration()).apiSubscriptionGet({});
    };

    public static GetCompanyInvoices = async () => {
        return new SubscriptionApi(GetApiConfiguration()).apiSubscriptionInvoicesGet();
    };

    public static DownloadCompanyInvoicePdf = async (invoiceId: number, invoiceNumber?: string | null): Promise<void> => {
        const response = await new SubscriptionApi(GetApiConfiguration()).apiSubscriptionInvoicesInvoiceIdPdfGetRaw({ invoiceId });
        const blob = await response.raw.blob();
        downloadBlobFile(blob, getFileNameFromContentDisposition(response.raw.headers.get('Content-Disposition'), `Faktura_${invoiceNumber ?? invoiceId}.pdf`));
    };


};